// header-nav.js
document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('hdn-open-menu');
  const closeBtn = document.getElementById('hdn-close-menu');
  const overlay = document.getElementById('hdn-overlay');
  const panel = document.getElementById('hdn-panel');

  const cartLink = document.getElementById('hdn-cart-link');
  cartLink?.addEventListener('click', function (e) {
    if (window.BPSCart && typeof window.BPSCart.open === 'function') {
      e.preventDefault();
      e.stopPropagation();
      window.BPSCart.open();
    }
    // if BPSCart isn't installed/loaded, the link falls through to /cart normally
  });

  if (!openBtn || !panel || !overlay) return;

  function open() {
    overlay.classList.add('hdn--open');
    panel.classList.add('hdn--open');
    document.documentElement.classList.add('overflow-hidden');
  }
  function close() {
    overlay.classList.remove('hdn--open');
    panel.classList.remove('hdn--open');
    document.documentElement.classList.remove('overflow-hidden');
  }

  openBtn.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keyup', (e) => { if (e.key === 'Escape') close(); });
});
